<template>
    <div class="my-2 overflow-hidden rounded-lg border border-blue-200 bg-white shadow-sm">
        <div class="flex items-center gap-2 border-b border-blue-100 bg-blue-50 px-4 py-2.5">
            <UIcon name="i-ion-sparkles" class="h-4 w-4 text-blue-600" />
            <span class="text-sm font-semibold text-slate-800">Proposed Product Context</span>
            <span class="ml-auto text-xs" :class="isSaved ? 'text-emerald-600' : 'text-blue-600'">
                {{ isSaved ? 'Saved' : 'Review before saving' }}
            </span>
        </div>

        <div class="whitespace-pre-wrap break-words px-4 py-3 text-sm leading-relaxed text-slate-700">
            {{ proposalContext }}
        </div>

        <div class="flex items-center justify-between gap-3 border-t border-slate-100 bg-slate-50 px-4 py-3">
            <div class="min-w-0">
                <p class="text-xs text-slate-500">
                    {{ isSaved ? 'This exact proposal is stored as organization-wide Product Context.' : 'Saving stores this exact text as durable, organization-wide Product Context.' }}
                </p>
                <p v-if="error" class="mt-1 text-xs text-red-600">{{ error }}</p>
            </div>
            <button
                v-if="!isSaved"
                type="button"
                class="flex-none rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-slate-300"
                :disabled="!canConfirm || !proposalId || saving"
                @click="confirm"
            >
                {{ saving ? 'Saving…' : 'Save Product Context' }}
            </button>
            <div v-else class="flex flex-none items-center gap-1.5 text-sm font-medium text-emerald-600">
                <UIcon name="i-heroicons-check-circle" class="h-4 w-4" />
                Saved
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    part: {
        output?: unknown;
    };
    canConfirm: boolean;
    saving?: boolean;
    error?: string | null;
}>();

const emit = defineEmits<{
    confirm: [];
}>();

const output = computed(() => {
    return typeof props.part.output === 'object' && props.part.output != null && !Array.isArray(props.part.output)
        ? props.part.output as Record<string, unknown>
        : {};
});

const proposalId = computed(() => typeof output.value.proposalId === 'string' ? output.value.proposalId : '');
const proposalContext = computed(() => typeof output.value.context === 'string' ? output.value.context : 'Preparing proposal…');
const isSaved = computed(() => output.value.status === 'saved');

function confirm() {
    if (props.canConfirm && proposalId.value && !props.saving && !isSaved.value) emit('confirm');
}
</script>
